module.exports = __webpack_public_path__ + "img/lightning.be5030ca.webp";